// auth.js
export const LOGOUT = 'LOGOUT';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';
export const IS_AUTHORISED = 'IS_AUTHORISED';
export const STORE_CSS = 'STORE_CSS';
export const CLEAR_CSS = 'CLEAR_CSS';
export const STORE_USER = 'STORE_USER';
export const GET_USER = 'GET_USER';
export const STORE_PROMO = 'STORE_PROMO';
export const GET_PROMO = 'GET_PROMO';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const AVAILABLE_APPLE_PAY = 'AVAILABLE_APPLE_PAY';

export const UPDATE_RESOURCE_KEY = 'UPDATE_RESOURCE_KEY';
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';
export const UPDATE_PARENT_PAGE = 'UPDATE_PARENT_PAGE';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js